// extracted by mini-css-extract-plugin
export var card = "_kc-5";
export var cardSelected = "_kc-4";
export var image = "_kc-3";
export var modal = "_kc-0";
export var modalContent = "_kc-1";
export var table = "_kc-2";